import React from "react";

import Drawer from "@material-ui/core/Drawer";
import { makeStyles } from "@material-ui/core/styles";

import WindowWidth from "components/WindowWidth.jsx";

import SideNavContent from "./SideNavContent";

const useStyles = makeStyles(theme => ({
  root: {
    "& .MuiPaper-root": {
      backgroundColor: "transparent",
      border: "none",
      width: "79px",
      marginTop: "48px",
      zIndex: 1
    }
  }
}));

const SideNav = props => {
  const [, width] = WindowWidth();
  const type = width < 1200 ? "persistent" : "permanent";
  const classes = useStyles();
  return (
    <>
      <Drawer variant={type} open onClose={props.onClose} className={classes.root}>
        <SideNavContent systemId={props.systemId} />
      </Drawer>
    </>
  );
};

export default SideNav;
